import { render, staticRenderFns } from "./luru.vue?vue&type=template&id=5af67caa&scoped=true&"
import script from "./luru.vue?vue&type=script&lang=ts&"
export * from "./luru.vue?vue&type=script&lang=ts&"
import style0 from "./luru.vue?vue&type=style&index=0&id=5af67caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af67caa",
  null
  
)

export default component.exports